<template #ChartsGraphic>
    <div class="charts-graphic">
        <div class="sub-header">
            <div class="left">
                <md-icon>help</md-icon>
                <div class="title">
                    {{ $t(`chatbotv2.${subTitle}`) }}
                </div>
            </div>
            <div class="right">
                <div class="export-button" @click="exportToCsv">
                    <md-icon>system_update_alt</md-icon>
                    <span>{{ $t("chatbotv2.exportToCsv") }}</span>
                </div>
                <div class="export-button" @click="exportToExcel">
                    <md-icon>system_update_alt</md-icon>
                    <span>{{ $t("chatbotv2.exportToExcel") }}</span>
                </div>
            </div>
        </div>
        <v-chart :options="heatmap" width="90%" />
    </div>
</template>

<script>
import VueECharts from "vue-echarts";
import "echarts/lib/chart/heatmap";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/grid";
import "echarts/lib/component/visualMap";
import { log2 } from "../../../../utils/log2";
import { expertToExcel, exportToCSV } from "../../../../utils/utils";
import moment from "moment";

const log = log2("ChartsGraphic");

export default {
    name: "ChartsGraphic",
    components: {
        "v-chart": VueECharts,
    },
    props: ["dataProp", "xAxisProp", "yAxisProp", "subTitle"],
    data() {
        return {
            xAxis: [
                "00:00",
                "01:00",
                "02:00",
                "03:00",
                "04:00",
                "05:00",
                "06:00",
                "07:00",
                "08:00",
                "09:00",
                "10:00",
                "11:00",
                "12:00",
                "13:00",
                "14:00",
                "15:00",
                "16:00",
                "17:00",
                "18:00",
                "19:00",
                "20:00",
                "21:00",
                "22:00",
                "23:00",
            ],
            yAxis: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
            chartData: this.dataProp,
            heatmap: {
                tooltip: {
                    position: "top",
                },
                animation: false,
                grid: {
                    height: "50%",
                    top: "10%",
                },
                xAxis: {
                    type: "category",
                    data: this.xAxis,
                    splitArea: {
                        show: true,
                    },
                },
                yAxis: {
                    type: "category",
                    data: this.yAxis,
                    splitArea: {
                        show: true,
                    },
                },
                visualMap: {
                    min: 0,
                    max: 10,
                    calculable: true,
                    orient: "horizontal",
                    left: "center",
                    bottom: "15%",
                    inRange: {
                        color: ["#d7e1e7", "#bbd7ea", "#9fccee", "#83c0f2", "#68b4f7", "#4ca7fb", "#2d99fe", "#018aff"], //From smaller to bigger value ->
                    },
                },
                series: [
                    {
                        type: "heatmap",
                        data: [],
                        label: {
                            show: true,
                        },
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowColor: "rgba(0, 0, 0, 0.5)",
                            },
                        },
                    },
                ],
                color: ["red", "yellow", "green"],
            },
        };
    },
    methods: {
        generateChart() {
            this.chartData = this.chartData.map((item) => {
                return [item[1], item[0], item[2] || "-"];
            });
            this.heatmap.series[0].data = this.dataProp;
            this.heatmap.xAxis.data = this.xAxisProp || this.xAxis;
            this.heatmap.yAxis.data = this.yAxisProp || this.yAxis;
        },
        exportToCsv() {
            const data = this.dataProp.map((item) => ({
                "Day of Week": moment().day(item[1]).format("dddd"),
                "Hour (24h)": moment().startOf("hour").hour(item[0]).format("HH:mm"),
                value: item[2],
            }));
            exportToCSV(data, `chatbot_busies_periods.csv`);
        },
        exportToExcel() {
            const data = this.dataProp.map((item) => ({
                "Day of Week": moment().day(item[1]).format("dddd"),
                "Hour (24h)": moment().startOf("hour").hour(item[0]).format("HH:mm"),
                value: item[2],
            }));
            expertToExcel(data, `chatbot_busies_periods.xlsx`, "Sheet 1");
        },
    },
    mounted() {
        log("this.dataProp", this.dataProp);
        if (!!this.heatmap && !!this.heatmap.visualMap) {
            this.heatmap.visualMap["max"] = _.max(this.dataProp.map((line) => line[2]));
            this.heatmap.visualMap["min"] = _.min(this.dataProp.map((line) => line[2]));
        }
        this.generateChart();
    },
};
</script>

<style lang="scss" scoped>
.sub-header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
    padding: 0px 20px;

    .left {
        display: flex;
        justify-content: space-between;
        align-items: center;

        i {
            font-size: 18px !important;
        }

        .title {
            font-size: 19px;
        }
    }

    .right {
        min-width: 80px;
        display: flex;
        gap: 10px;
        padding: 5px 10px;
        user-select: none;

        .export-button {
            border: 1px solid #008aff;
            padding: 5px;
            cursor: pointer;
            color: #008aff;
            border-radius: 4px;

            &:hover {
                background: var(--color-bg-hover);
            }

            i {
                color: #008aff;
                font-size: 17px !important;
            }
        }
    }
}

.data-info {
    width: 20%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-left: 20px;
    margin-bottom: 20px;
    margin-top: 20px;

    .total {
        margin-right: 20px;
        font-weight: 600;
        line-height: 23px;

        p {
            margin: 0;
            padding: 0;
        }

        .data-value {
            font-size: 28px;
            line-height: 36px;
        }
    }

    .avg {
        font-weight: 600;
        line-height: 23px;

        p {
            margin: 0;
            padding: 0;
        }

        .data-value {
            font-size: 28px;
            line-height: 36px;
        }
    }
}

.echarts {
    width: 90% !important;
    /* height: 100% !important; */
}
</style>
